function fn_comp_category() {
    var $fn = $(".comp_category");

    if ($fn.length){
        history.replaceState("", document.title, window.location.pathname + window.location.search);
    }
}